import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { resetPasswordByToken } from '../../services/auth';

const ResetPasswordPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [newPassword, setNewPassword] = React.useState('');
  const [confirmPassword, setConfirmPassword] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const [tip, setTip] = React.useState('');
  const uid = searchParams.get('uid') || '';
  const token = searchParams.get('token') || '';

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!uid || !token) {
      setTip('重置链接无效');
      return;
    }
    setLoading(true);
    setTip('');
    try {
      const resp = await resetPasswordByToken({
        uid,
        token,
        new_password: newPassword,
        confirm_password: confirmPassword,
      });
      setTip(resp?.detail || '密码重置成功，请返回登录');
    } catch (err: any) {
      setTip(err?.response?.data?.detail || '重置失败，请稍后重试');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="bg-white p-8 rounded-lg shadow-md w-[520px]">
        <h1 className="text-2xl font-bold mb-6 text-center">重置密码</h1>
        {tip ? <div className="mb-4 rounded border border-blue-200 bg-blue-50 px-3 py-2 text-sm text-blue-700">{tip}</div> : null}
        <form onSubmit={submit}>
          <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="newPwd">新密码</label>
          <input
            id="newPwd"
            type="password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="至少6位"
            disabled={loading}
            required
          />

          <label className="block text-gray-700 text-sm font-bold mb-2 mt-4" htmlFor="confirmPwd">确认密码</label>
          <input
            id="confirmPwd"
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="再次输入新密码"
            disabled={loading}
            required
          />

          <button
            type="submit"
            className="mt-6 w-full bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600 disabled:opacity-60"
            disabled={loading}
          >
            {loading ? '提交中...' : '确认重置'}
          </button>
        </form>
        <div className="mt-4 text-center text-sm">
          <Link to="/login" className="text-blue-600 hover:text-blue-700">返回登录</Link>
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordPage;
